interface ZoomImageProps {
  src: string;
  zoomKey: number;
}

export function ZoomImage({ src, zoomKey }: ZoomImageProps) {
  return (
    <div className="zoom-frame" key={zoomKey}>
      <img
        src={src}
        alt="Énigme du jour — portion zoomée"
        className="zoom-image"
        draggable={false}
      />
    </div>
  );
}
